import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    padding: 0,
    boxShadow: Depths.depth4,
    backgroundColor: theme.palette.neutralWhite,
  },
  bottomBorderPurple: {
    paddingBottom: pxToRem(20),
    borderBottom: `${theme.palette.themePrimary} solid ${pxToRem(4)}`,
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingBottom: pxToRem(18),
        borderBottom: `${theme.palette.themePrimary} solid ${pxToRem(6)}`,
      },
    },
  },
});
